export default {
    placeholder: 'Bitte wählen…',
    searchPlaceholder: 'Suchen…',
    emptyText: 'Keine Treffer',
};
